import ShButton from "@/components/Helpers/ShButton";
import {
  hAmountOfSmsNeeded,
  isGsmMessage,
  getGsmMessageDoubleCharactersAmount,
  replaceAllPolishCharacters
} from "@/utils/helpers";
import { messageLimits } from "@/utils/consts";

export default {
  name: "PopoverSmsGateway",

  components: {
    ShButton
  },

  props: {
    projectsList: {
      type: Array,
      default: () => []
    },
    projectUuid: {
      type: String,
      default: ""
    },
    connection: {
      type: Object,
      default: () => {}
    },
    isPopoverOnIncomingList: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isSmsPopoverVisible: false,
      form: {
        smsContent: "",
        smsHeader: "",
        template: "",
        project: ""
      },
      smsContentCount: 0,
      arePolishCharactersRemoved: false,
      rules: {
        project: [{ required: true, message: "Projekt jest wymagany.", trigger: "blur" }],
        smsHeader: [{ required: true, message: "Nagłówek jest wymagany.", trigger: "blur" }],
        smsContent: [
          {
            required: true,
            message: "Treść wiadomości jest wymagana.",
            trigger: ["blur", "change"]
          },
          {
            min: 1,
            max: 918,
            message: "Długość wiadomości musi mieć min. 1 i max. 918 znaków.",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    if (this.smsHeadersList.length === 1) {
      this.form.smsHeader = this.smsHeadersList[0].user_name_uuid;
    }
  },
  watch: {
    projectsList: {
      handler(list) {
        if (list.length === 1 && isPopoverOnIncomingList) {
          this.form.project = list[0].uuid;
          this.selectProject(this.form.project);
        }
      },
      immediate: true
    },
    isSmsPopoverVisible: {
      handler() {
        this.$emit("isSmsPopoverActive", this.isSmsPopoverVisible);
      }
    },
    arePolishCharactersRemoved: {
      handler(val) {
        const specialCharacters = getGsmMessageDoubleCharactersAmount(this.form.smsContent);
        if (val) {
          this.smsContentCount = this.form.smsContent.length + specialCharacters;
        } else {
          const numberOfSpecialCharacters = this.smsContentHasSpecialCharacters
            ? 0
            : specialCharacters;
          this.smsContentCount = this.form.smsContent.length + numberOfSpecialCharacters;
        }
      }
    }
  },

  computed: {
    smsCounter() {
      return hAmountOfSmsNeeded(this.smsContentCount, this.smsContentHasSpecialCharacters);
    },
    smsHeadersList() {
      return this.$store.getters["sms/headersList"];
    },
    smsTemplatesList() {
      return this.$store.getters["sms/templatesList"];
    },
    isTemplatesLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "sms/getSmsTemplatesList"
      ]);
    },
    isLoading() {
      return this.$store.getters["global/pendingAsyncStoreActions"].includes([
        "sms/addSmsToQueue",
        "sms/sendAllSmsFromProject"
      ]);
    },
    smsContentLimit() {
      if (this.arePolishCharactersRemoved) return messageLimits.noSpecialCharacters;
      return this.smsContentHasSpecialCharacters
        ? messageLimits.withSpecialCharacters
        : messageLimits.noSpecialCharacters;
    },
    smsContentHasSpecialCharacters() {
      if (this.arePolishCharactersRemoved) return false;
      return !isGsmMessage(this.form.smsContent);
    }
  },

  methods: {
    handleSmsContentInput(value) {
      if (this.smsContentCount >= this.smsContentLimit) {
        if (value >= this.form.smsContent) {
          return;
        }
      }
      this.form.smsContent = value;
      const numberOfSpecialCharacters = this.smsContentHasSpecialCharacters
        ? 0
        : getGsmMessageDoubleCharactersAmount(value);
      this.smsContentCount = value.length + numberOfSpecialCharacters;
    },
    submitForm() {
      if (this.smsContentCount > this.smsContentLimit) {
        this.$message({
          type: "error",
          message: "Długość wiadomości wykracza poza limit"
        });
        return;
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = {
            uuid_project: this.isPopoverOnIncomingList ? this.form.project : this.projectUuid,
            uuid_src: this.form.smsHeader,
            dst: this.isPopoverOnIncomingList
              ? this.connection.from_number
              : this.connection._num_a || this.connection._number_a,
            text: this.arePolishCharactersRemoved
              ? replaceAllPolishCharacters(this.form.smsContent)
              : this.form.smsContent
          };
          const queueStatus = await this.$store.dispatch("sms/addSmsToQueue", params);
          const sendStatus = await this.$store.dispatch(
            "sms/sendAllSmsFromProject",
            this.isPopoverOnIncomingList ? this.form.project : this.projectUuid
          );
          if (queueStatus === 200 && sendStatus === 200) {
            this.$message({
              type: "success",
              message: "Sms wysłany pomyślnie."
            });
            this.form.smsContent = "";
            this.form.template = "";
          } else {
            this.$message({
              type: "error",
              message: "Wystąpił błąd podczas wysyłania SMS'a."
            });
          }
        }
      });
    },
    selectTemplate(templateContent) {
      this.form.smsContent = templateContent;
    },
    selectProject(projectUuid) {
      this.$store.dispatch("sms/getSmsTemplatesList", projectUuid);
    },
    clearTemplate() {
      this.form.smsContent = "";
      this.smsContentCount = 0;
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    async showPopover() {
      this.resetForm();
      if (!this.isPopoverOnIncomingList) {
        await this.$store.dispatch("sms/getSmsTemplatesList", this.projectUuid);
      }
    }
  }
};
